module.exports = __webpack_public_path__ + "static/und-a0956eb990ccc130cdbf0d59829fa8ca.png";